import { InventoryTypeId } from '@carvana/merch-contracts/InventoryType';
import { axios, httpWithAuth } from '~/clients';
import ClientId from '~/constants/ClientId';
import { GET_PERSONALIZED_RECOMMENDATIONS } from '~/constants/endpoints';
import { blobCdnUrl, vexCdnUrl } from '~/constants/environment';
import PurchaseType from '~/constants/purchaseType';
import recommendationSource from '~/constants/recommendationSource';
import { VehicleLockTypeKey } from '~/constants/vehicleLockType';
import type { AppliedFilters, RecommendedVehicle } from '~/contracts/common';

export type PersonalizedRecommendationFilters = AppliedFilters & {
  lockTypes?: VehicleLockTypeKey[];
  purchaseTypes?: PurchaseType[];
};

type RecommendedPayload = {
  analyticsData: {
    correlationId: string;
    searchRequestId: string;
    isMobileDevice: boolean;
    browser: string;
    filterSource: string;
    referrer: string;
  };
  browserCookieId: string;
  clientId: ClientId;
  filters?: PersonalizedRecommendationFilters;
  numVehiclesToReturn: number;
  sortBy?: string;
  vehicleId: number;
  zip5: string;
};

type VehicleFromRecommendations = Omit<
  RecommendedVehicle,
  'imageUrl' | 'isFavorited' | 'vehicleUnlockDateTime'
> & {
  imageUrl?: string;
  vehicleUnlockDateTime: string;
};

export default async function fetchPersonalizedRecommendations(
  payload: RecommendedPayload,
  isLoggedIn: boolean,
  controller: AbortController
): Promise<RecommendedVehicle[]> {
  const fetcher = isLoggedIn ? httpWithAuth : axios;

  const data = await fetcher.post<{
    source: typeof recommendationSource;
    vehicles: VehicleFromRecommendations[];
  }>(GET_PERSONALIZED_RECOMMENDATIONS, payload, { signal: controller.signal });

  return data.data.vehicles.map(
    (vehicle: VehicleFromRecommendations): RecommendedVehicle => ({
      ...vehicle,
      imageUrl:
        vehicle.imageUrl == null ||
        vehicle.vehicleInventoryType === InventoryTypeId.DealerMarketplace
          ? `${vexCdnUrl}/${vehicle.stockNumber}/hero.jpg`
          : `${blobCdnUrl}${vehicle.imageUrl}`,
      isFavorited: false
    })
  );
}
